import { render, staticRenderFns } from "./recupararSenha.vue?vue&type=template&id=f173290e&scoped=true&"
import script from "./recupararSenha.vue?vue&type=script&lang=js&"
export * from "./recupararSenha.vue?vue&type=script&lang=js&"
import style0 from "./recupararSenha.vue?vue&type=style&index=0&id=f173290e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f173290e",
  null
  
)

export default component.exports